import { useLanguageData } from '@/common/hooks/useLanguageData';
import ResetPasswordModal from '../ResetPasswordModal';
import {
	AuthError,
	AuthFormBottom,
	AuthFormEl,
	AuthFormFields,
	AuthFormRoot,
} from '../authModal.styles';
import AuthEmailField from './components/AuthEmailField';
import AuthLoginPasswordField from './components/AuthLoginPasswordField';
import AuthPasswordRegisterFields from './components/AuthPasswordRegisterFields';
import AuthFormStepLinks from './components/AuthFormStepLinks';
import AuthFormSubmitButton from './components/AuthFormSubmitButton';
import { AUTH_STEPS } from './constants/authForm.constants';
import { useAuthForm } from './hooks/useAuthForm';
import { useResetPassword } from './hooks/useResetPassword';

const AuthForm = ({ mode = 'register', onSuccess, onStepChange }) => {
	const translations = useLanguageData('login');

	const {
		email,
		setEmail,
		password,
		setPassword,
		confirmPassword,
		setConfirmPassword,
		error,
		currentStep,
		normalizedEmail,
		handleSubmit,
		handleGoBack,
		isCheckEmailLoading,
		isAuthPending,
		isAuthSuccess,
		isSubmitDisabled,
	} = useAuthForm({ mode, onSuccess, onStepChange, translations });

	const {
		isResetModalOpen,
		resetEmail,
		setResetEmail,
		resetMessage,
		resetSuccess,
		isResetLoading,
		openResetModal,
		closeResetModal,
		handleResetSubmit,
		handleResetSuccessConfirm,
	} = useResetPassword(normalizedEmail, email);

	return (
		<>
			<AuthFormRoot>
				<AuthFormEl onSubmit={handleSubmit}>
					<AuthFormFields>
						{error && <AuthError>{error}</AuthError>}
						<AuthEmailField
							email={email}
							onEmailChange={setEmail}
							currentStep={currentStep}
							isCheckEmailLoading={isCheckEmailLoading}
							isAuthPending={isAuthPending}
							isAuthSuccess={isAuthSuccess}
							translations={translations}
						/>
						{currentStep === AUTH_STEPS.PASSWORD_LOGIN && (
							<AuthLoginPasswordField
								password={password}
								onPasswordChange={setPassword}
								isAuthPending={isAuthPending}
								isAuthSuccess={isAuthSuccess}
								translations={translations}
							/>
						)}
						{(currentStep === AUTH_STEPS.PASSWORD_SET ||
							currentStep === AUTH_STEPS.PASSWORD_REGISTER) && (
							<AuthPasswordRegisterFields
								step={currentStep}
								password={password}
								confirmPassword={confirmPassword}
								onPasswordChange={setPassword}
								onConfirmPasswordChange={setConfirmPassword}
								translations={translations}
							/>
						)}
						<AuthFormStepLinks
							currentStep={currentStep}
							onGoBack={handleGoBack}
							onForgotPassword={openResetModal}
							translations={translations}
						/>
					</AuthFormFields>
					<AuthFormBottom>
						<AuthFormSubmitButton
							currentStep={currentStep}
							mode={mode}
							isCheckEmailLoading={isCheckEmailLoading}
							isAuthPending={isAuthPending}
							isAuthSuccess={isAuthSuccess}
							isSubmitDisabled={isSubmitDisabled}
							translations={translations}
						/>
					</AuthFormBottom>
				</AuthFormEl>
			</AuthFormRoot>
			{isResetModalOpen && (
				<ResetPasswordModal
					email={resetEmail}
					resetMessage={resetMessage}
					isLoading={isResetLoading}
					isSuccess={resetSuccess}
					onEmailChange={setResetEmail}
					onSubmit={handleResetSubmit}
					onClose={closeResetModal}
					onConfirmSuccess={handleResetSuccessConfirm}
				/>
			)}
		</>
	);
};

export default AuthForm;
